module.exports = __webpack_public_path__ + "img/tuletorn.8a9b181f.jpg";